import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, ShieldCheck, ChevronDown } from 'lucide-react';
const testimonials2 = [{
  initials: 'CR',
  text: 'El Mapa de Tiempos me salvó la vida. Mis milanesas salen perfectas todas las veces.',
  author: 'Cecilia R.',
  city: 'Mendoza'
}, {
  initials: 'SC',
  text: 'El Planificador fue lo que necesitaba. Ya no pienso qué cocinar. Todo resuelto.',
  author: 'Sofía C.',
  city: 'La Plata'
}, {
  initials: 'MV',
  text: 'Dejé de pedir delivery. Con el Meal Prep tengo la semana resuelta desde el domingo.',
  author: 'Mónica V.',
  city: 'Tucumán'
}, {
  initials: 'JL',
  text: 'Tenía la freidora guardada hace 6 meses. Con el AirPack la uso todos los días.',
  author: 'Jorge L.',
  city: 'Rosario'
}];
const faqs = [{
  q: '¿Sirve para cualquier modelo de freidora?',
  a: 'Sí. El Tomo 6 incluye tabla de ajuste para los modelos más vendidos en Argentina.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Por email en menos de 5 minutos después del pago.'
}, {
  q: '¿Qué lo diferencia de buscar en Google?',
  a: 'Todo está calibrado para ingredientes, cortes y freidoras argentinas reales. No son recetas genéricas traducidas.'
}, {
  q: '¿Necesito saber cocinar?',
  a: 'No. Si podés seguir instrucciones simples, podés hacer cualquier receta del AirPack.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días, 100% del dinero de vuelta. Sin preguntas.'
}];
export function Trust() {
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  return <section className="py-20 md:py-32 bg-cream relative" data-id="element-280">
      <div className="max-w-5xl mx-auto px-4" data-id="element-281">
        {/* Stats Band */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-24" data-id="element-282">
          <h2 className="text-sm font-bold tracking-widest text-charcoal/50 uppercase text-center mb-8" data-id="element-283">
            Lo están usando hogares reales
          </h2>
          <div className="bg-white border border-sand rounded-2xl p-8 md:p-12 shadow-sm" data-id="element-284">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-4 divide-y md:divide-y-0 md:divide-x divide-sand/60 text-center" data-id="element-285">
              <div className="pt-4 md:pt-0" data-id="element-286">
                <div className="text-4xl md:text-5xl font-serif font-bold text-charcoal mb-2" data-id="element-287">
                  +1.200
                </div>
                <div className="text-sm font-bold text-charcoal/50 uppercase tracking-widest" data-id="element-288">
                  hogares
                </div>
              </div>
              <div className="pt-8 md:pt-0" data-id="element-289">
                <div className="text-4xl md:text-5xl font-serif font-bold text-charcoal mb-2" data-id="element-290">
                  Miles
                </div>
                <div className="text-sm font-bold text-charcoal/50 uppercase tracking-widest" data-id="element-291">
                  de recetas preparadas
                </div>
              </div>
              <div className="pt-8 md:pt-0" data-id="element-292">
                <div className="text-4xl md:text-5xl font-serif font-bold text-charcoal mb-2" data-id="element-293">
                  4.9<span className="text-2xl text-charcoal/40" data-id="element-294">/5</span>
                </div>
                <div className="text-sm font-bold text-charcoal/50 uppercase tracking-widest" data-id="element-295">
                  calificación promedio
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Testimonials 2 */}
        <div className="mb-24" data-id="element-296">
          {/* USER NOTE: To add real screenshots later, you can replace these motion.div cards with <img src="screenshot.jpg" className="rounded-xl shadow-sm border border-sand" /> */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-297">
            {testimonials2.map((t, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex flex-col gap-3 p-5 rounded-xl bg-white border border-sand shadow-sm" data-id="element-298">
                <div className="flex items-center gap-3 mb-2" data-id="element-299">
                  <div className="w-8 h-8 rounded-full bg-charcoal/5 text-charcoal flex items-center justify-center font-bold text-xs" data-id="element-300">
                    {t.initials}
                  </div>
                  <div className="flex text-amber-400" data-id="element-301">
                    {[...Array(5)].map((_, j) => <Star key={j} size={12} fill="currentColor" data-id="element-302" />)}
                  </div>
                </div>
                <p className="text-charcoal/80 text-sm font-medium italic flex-grow" data-id="element-303">
                  "{t.text}"
                </p>
                <div data-id="element-304">
                  <p className="text-xs text-charcoal/80 font-bold uppercase tracking-wide" data-id="element-305">
                    {t.author}, {t.city}
                  </p>
                  <p className="text-[10px] text-green-600 font-semibold uppercase tracking-widest mt-1 flex items-center gap-1" data-id="element-306">
                    <ShieldCheck size={10} data-id="element-307" /> Compra verificada
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>

        {/* Guarantee */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto bg-white border-2 border-charcoal rounded-2xl p-8 md:p-12 text-center shadow-editorial mb-24" data-id="element-308">
          <div className="w-16 h-16 bg-cream rounded-full flex items-center justify-center mx-auto mb-6 border border-sand" data-id="element-309">
            <ShieldCheck size={32} className="text-charcoal" data-id="element-310" />
          </div>
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-charcoal mb-4" data-id="element-311">
            GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>
          <p className="text-charcoal/80 text-lg leading-relaxed max-w-xl mx-auto" data-id="element-312">
            Abrís los tomos. Los usás en tu cocina. Si en 7 días no es lo que
            esperabas: devolución del 100%. Sin formularios. Sin drama.
            <span className="block mt-4 text-sm font-bold text-charcoal/50 uppercase tracking-widest" data-id="element-313">
              Tasa de devoluciones: menos del 1%.
            </span>
          </p>
        </motion.div>

        {/* FAQ */}
        <div className="max-w-3xl mx-auto" data-id="element-314">
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-center mb-10 flex items-center justify-center gap-2" data-id="element-315">
            <span className="text-charcoal/40" data-id="element-316">❓</span> LO QUE MÁS NOS
            PREGUNTAN
          </h2>
          <div className="space-y-4" data-id="element-317">
            {faqs.map((faq, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-white border border-sand rounded-xl overflow-hidden" data-id="element-318">
                <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full flex items-center justify-between p-5 text-left focus:outline-none" data-id="element-319">
                  <span className="font-bold text-charcoal pr-4" data-id="element-320">{faq.q}</span>
                  <motion.div animate={{
                rotate: openFaq === i ? 180 : 0
              }} transition={{
                duration: 0.2
              }} data-id="element-321">
                    <ChevronDown size={20} className="text-charcoal/40" data-id="element-322" />
                  </motion.div>
                </button>
                <AnimatePresence data-id="element-323">
                  {openFaq === i && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2
              }} data-id="element-324">
                      <div className="p-5 pt-0 text-charcoal/70 text-sm leading-relaxed border-t border-sand/30 mt-2" data-id="element-325">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}